import { getFirestore, doc, updateDoc, Timestamp } from "firebase/firestore";
import { app } from "../config";

const db = getFirestore(app);

// Function to update an existing MPS application
const updateMPSApplication = async (registrationData, applicationId) => {
    try {
        // Get a reference to the existing document using the provided applicationId
        const applicationRef = doc(db, "mpsEventRegistration", applicationId);

        // Update only the necessary fields, keeping the rest of the document unchanged
        const updateData = {
            ...registrationData, // Spread the existing registration data
            updatedAt: Timestamp.now(), // Update the timestamp
        };

        await updateDoc(applicationRef, updateData);
        console.log("Document updated with ID: ", applicationId);
        return { success: true, documentId: applicationId };

    } catch (error) {
        console.error("Error updating document: ", error);
        return { success: false, message: error.message };
    }
};

export { updateMPSApplication };